export default __webpack_public_path__ + "static/media/notifactions.734d6103.svg";